import { Injectable } from "@angular/core";
import { BillingService } from "@edp-services/billing.service";
import { EBillingActions, GetMontlhyInvoices, GetTariffFiles } from "@edp-store/actions/billing.actions";
import { ELayoutActions, ShowLoader } from "@edp-store/actions/layout.actions";
import { IAppState } from "@edp-store/state/app.state";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { catchError, switchMap } from "rxjs/operators";

@Injectable()
export class BillingEffects {
    loadMonthlyInvoices$ = createEffect(() =>
        this.actions$.pipe(
            ofType(EBillingActions.GetMontlhyInvoices),
            switchMap((payload: GetMontlhyInvoices) => {
                this.store.dispatch(new ShowLoader(true));
                return this.billingService.getMonthlyInvoices(payload.contractId).pipe(
                    switchMap(response => [
                        { type: EBillingActions.SetMontlhyInvoices, payload: response },
                        { type: ELayoutActions.ShowLoader, payload: false },
                    ]),
                    catchError(() => [{ type: ELayoutActions.ShowLoader, payload: false }])
                );
            })
        )
    );

    getTariffFiles$ = createEffect(() =>
        this.actions$.pipe(
            ofType(EBillingActions.GetTariffFiles),
            switchMap((action: GetTariffFiles) => {
                this.store.dispatch(new ShowLoader(true));
                return this.billingService.getTariffFiles(action.payload).pipe(
                    switchMap(response => [
                        { type: EBillingActions.SetTariffFiles, payload: response },
                        { type: ELayoutActions.ShowLoader, payload: false },
                    ]),
                    catchError(() => [{ type: ELayoutActions.ShowLoader, payload: false }])
                );
            })
        )
    );

    constructor(private actions$: Actions, private billingService: BillingService, private store: Store<IAppState>) {}
}
